import React from 'react';
import "../../Assets/CSS/Home.scss";
import schoolIcon from '../../Assets/Images/Homepage/Icons/ERPsections/schoolicon.png';
import collegeIcon from '../../Assets/Images/Homepage/Icons/ERPsections/college.png';
import trustIcon from '../../Assets/Images/Homepage/Icons/ERPsections/credibility.png';
import { Container } from 'react-bootstrap';

const TailoredERPSolutions = () => {
    const solutions = [
        {
            logo: schoolIcon,
            title: "School ERP",
            description: "Comprehensive management system for K-12 schools with attendance tracking, grade management, and parent communication.",
            benefits: [
                "Automated attendance tracking",
                "Real-time grade reporting",
                "Parent-teacher communication",
                "Fee management system"
            ],
            cta: "Explore School ERP →"
        },
        {
            logo: collegeIcon,
            title: "College ERP",
            description: "Advanced ERP solution for colleges and universities with course management, admissions, and analytics.",
            benefits: [
                "Course & curriculum management",
                "Online admissions portal",
                "Student lifecycle tracking",
                "Advanced analytics dashboard"
            ],
            cta: "Explore College ERP →"
        },
        {
            logo: trustIcon,
            title: "Trust Management",
            description: "Specialized solution for educational trusts managing multiple institutions with centralized oversight.",
            benefits: [
                "Multi-campus management",
                "Centralized reporting",
                "Resource allocation",
                "Performance benchmarking"
            ],
            cta: "Explore Trust Management →"
        }
    ];

    return (

        <Container>
            <div className='bg-gray-50'>
                <div className="mx-auto px-6 sm:px-6 lg:px-20 py-8">
                    {/* Header Section */}
                    <div className="text-center mb-2">
                        <h2 className="Headers font-ui">Tailored ERP Solutions for Every Educational Need</h2>
                        <p className="subHeads font-ui">
                            From K-12 schools to universities and educational trusts, we provide specialized
                            ERP solutions that scale with your institution's unique requirements.
                        </p>
                    </div>

                    {/* Cards Grid */}
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 mb-5">
                        {solutions.map((solution, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col h-full"
                            >
                                <div className='p-6 flex flex-col h-full'>
                                    <div>
                                        <img src={solution.logo} alt="ERPSolutions" className="h-12 mb-4" />
                                    </div>
                                    <h3 className="solutionTitle font-heading font-bold">{solution.title}</h3>
                                    <p className="solutionDesc mb-4">{solution.description}</p>

                                    <div className="mb-6">
                                        <h4 className="solutionKeys font-bold">Key Benefits:</h4>
                                        <ul className="solutionlist space-y-2 mt-2">
                                            {solution.benefits.map((benefit, i) => (
                                                <li key={i} className="flex items-start">
                                                    <span className="points mr-2">•</span>
                                                    <span className="text-gray-600">{benefit}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Button container with mt-auto to push to bottom */}
                                    <div className="mt-auto pt-1">
                                        <button className="ctaButton font-ui w-full hover:bg-blue-600 transition-colors">
                                            {solution.cta}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default TailoredERPSolutions;


